import React from 'react';
import ReactDOM from 'react-dom/client';
import { installTrustedTypes } from './lib/trusted-types.js';
import { App } from './App.js';
import './index.css';

// Install Trusted Types default policy BEFORE React mounts. React 18
// hydration uses innerHTML on the root, which a strict CSP
// `require-trusted-types-for 'script'` would reject without a default
// policy being present.
installTrustedTypes();

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
